import api from './api';

/**
 * "Connect my Telegram" — `/api/v1/messaging/connect-link/`.
 *
 * For a POSP (or a customer with a portal login) whose Telegram number is not
 * the one on their record. Everything is resolved server-side from the
 * logged-in user: the link opens THEIR broker's bot, works once, and expires
 * after ten minutes.
 */

export interface TelegramConnectStatus {
  /** false: the broker has no connected Telegram bot to connect to. */
  available: boolean;
  /** A verified chat on that bot already links this login. */
  connected: boolean;
  bot_username: string;
  connected_at: string | null;
}

export interface TelegramConnectLink {
  /** https://t.me/<bot>?start=<one-time code> */
  url: string;
  expires_at: string;
  bot_username: string;
}

export const telegramConnectApi = {
  async getStatus(): Promise<TelegramConnectStatus> {
    const { data } = await api.get<TelegramConnectStatus>('/messaging/connect-link/status/');
    return data;
  },

  async createLink(): Promise<TelegramConnectLink> {
    const { data } = await api.post<TelegramConnectLink>('/messaging/connect-link/', {});
    return data;
  },
};
